/**
 * SUIVI-CRO — tracker d'événements, identique sur toutes les boutiques.
 * Source : ~/Dev/DROP ADS/SUIVI-CRO/client/cro-tracker.js
 *
 * Exige l'amorce snippets/cro-tracker-head.liquid, qui pose window.CRO (configuration, identité,
 * attribution). Ce script ne décide jamais de l'identité : il reprend celle de l'amorce.
 *
 * Contrat avec le thème — le tracker ne connaît AUCUNE classe CSS de thème :
 *   data-cro="<événement>"         un clic envoie cet événement
 *   data-cro-label="…"             libellé (sinon aria-label, sinon texte)
 *   data-cro-value="…"             valeur numérique facultative
 *   data-cro-vu="<événement>"      envoyé une fois, quand l'élément devient visible
 *   data-cro-panier-lateral        le panier latéral (tiroir) : cart_open à chaque ouverture, même automatique
 *                                  après un ajout, et cart_close (value = secondes ouvert) à sa fermeture
 *   window.croTrack(nom, props)    pour tout le reste (carrousel, étapes internes…)
 * Automatique, sans marquage : vues, ajout au panier (formulaire /cart/add + réponse réseau),
 * panier, checkout (bouton « Commander » ou paiement express : Shop Pay, Apple Pay, Google Pay… → meta.x = 1), défilement, blocs vus, accordéons <details>, premier geste, rage, vitesse.
 * Les noms d'événements sont ceux de CATMATIK : un seul moteur d'analyse pour toutes les boutiques.
 */
(function () {
  'use strict';

  var CFG = window.CRO || {};
  if (!CFG.endpoint || window !== window.top) return;
  var CORE = CFG.core || {};

  var SESSION_MAX_IDLE = 30 * 60 * 1000;
  var FLUSH_MS = 3000;
  var DEVISE = CFG.devise || 'EUR';

  function ls(key, val) {
    try { if (val === undefined) return localStorage.getItem(key); localStorage.setItem(key, val); return val; }
    catch (e) { return null; }
  }
  function ss(key, val) {
    try { if (val === undefined) return sessionStorage.getItem(key); sessionStorage.setItem(key, val); return val; }
    catch (e) { return null; }
  }
  function st(key, val) { var r = ls(key, val); return r !== null ? r : ss(key, val); }
  function uid() {
    try { return crypto.randomUUID(); }
    catch (e) { return 'x' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  }
  function txt(el, max) {
    return ((el && (el.getAttribute('aria-label') || el.textContent)) || '').replace(/\s+/g, ' ').trim().slice(0, max || 80) || null;
  }

  /* ── identité : celle de l'amorce ── */
  var PN = CORE.pn || 1;
  var visitorId = CORE.vid || ls('cro_vid') || uid();
  var sessionId = st('cro_sid') || CORE.sid || uid();
  var attrib = CORE.attrib || {};
  var interne = !!CORE.interne;

  // Appareil figé pour la session, mesuré ici : en fin de page la balise viewport est appliquée.
  var deviceType = ss('cro_dev');
  if (!deviceType) {
    var w0 = window.innerWidth;
    deviceType = w0 < 768 ? 'mobile' : w0 < 1024 ? 'tablet' : 'desktop';
    ss('cro_dev', deviceType);
  }

  var base = 0;
  function now() { return window.performance && performance.now ? performance.now() : 0; }
  function sec() { return Math.round((now() - base) / 100) / 10; }
  function metaP(m) { m.p = PN; return JSON.stringify(m); }

  /* ── file d'attente ── */
  var queue = [], timer = null;
  function flush(sync) {
    if (!queue.length) return;
    var payload = JSON.stringify(queue.splice(0, 50));
    clearTimeout(timer); timer = null;
    var sent = false;
    // sendBeacon survit à la fermeture de l'onglet.
    if (sync && navigator.sendBeacon) {
      try { sent = navigator.sendBeacon(CFG.endpoint, new Blob([payload], { type: 'text/plain' })); } catch (e) {}
    }
    if (!sent) {
      try {
        fetch(CFG.endpoint, { method: 'POST', body: payload, keepalive: true, headers: { 'Content-Type': 'text/plain' } })
          .catch(function () {});
      } catch (e) {}
    }
    if (queue.length) flush(sync);
  }

  function track(name, props) {
    var e = props || {};
    e.name = name;
    e.client_ts = Date.now();
    e.visitor_id = visitorId;
    e.session_id = sessionId;
    e.path = location.pathname;
    e.device = deviceType;
    e.template = CFG.template || null;
    if (e.product_id === undefined && CFG.productId) e.product_id = CFG.productId;
    if (e.label === undefined && CFG.productTitle && e.product_id === CFG.productId &&
        (name === 'product_view' || name === 'page_view')) e.label = CFG.productTitle;
    e.gclid = attrib.gclid || null;
    e.epik = attrib.epik || null;
    e.utm_source = attrib.utm_source || null;
    e.utm_medium = attrib.utm_medium || null;
    e.utm_campaign = attrib.utm_campaign || null;
    e.utm_term = attrib.utm_term || null;
    e.utm_content = attrib.utm_content || null;
    e.referrer = attrib.referrer || null;
    e.landing_page = attrib.landing_page || null;
    try { if (navigator.webdriver === true) e.wd = true; } catch (x) {}
    if (interne) e.int = true;
    queue.push(e);
    versClarity(name);
    st('cro_seen', Date.now());
    if (!timer) timer = setTimeout(function () { flush(false); }, FLUSH_MS);
  }
  window.croTrack = track;

  /* ── pont vers Microsoft Clarity, s'il est installé ──
     Notre identifiant de session devient un filtre dans Clarity : on retrouve la vidéo d'une visite. */
  var CLARITY_EVENTS = { add_to_cart_click: 1, add_to_cart: 1, cart_open: 1, checkout_start: 1,
    faq_open: 1, rage_click: 1, sticky_ajout: 1, offre_formule: 1 };
  var CLARITY_UPGRADE = { add_to_cart_click: 1, add_to_cart: 1, checkout_start: 1 };
  var clarityTagge = false;
  function versClarity(name) {
    var c = window.clarity;
    if (typeof c !== 'function') return;
    try {
      if (!clarityTagge) {
        clarityTagge = true;
        c('identify', visitorId, sessionId);
        c('set', 'cro_session', sessionId);
        if (attrib.utm_campaign) c('set', 'cro_campagne', attrib.utm_campaign);
        if (CFG.productHandle) c('set', 'cro_produit', CFG.productHandle);
        if (CORE.ab) c('set', 'cro_ab', CORE.ab.t + '|' + CORE.ab.v);
        if (CORE.abp) c('set', 'cro_abp', CORE.abp.t + '|' + CORE.abp.v);
        if (CORE.tests) Object.keys(CORE.tests).forEach(function (z) { c('set', 'cro_t_' + z, CORE.tests[z].t + '|' + CORE.tests[z].v); });
      }
      if (CLARITY_EVENTS[name]) c('event', name);
      if (CLARITY_UPGRADE[name]) c('upgrade', name);
    } catch (e) {}
  }

  /* ── identifiants jusqu'à la commande ──
     Les attributs du panier sont le seul lien entre la visite et l'achat quand le pixel du
     checkout ne lit pas le stockage du navigateur. Poussés pour tout le monde, pas seulement
     pour le trafic payant. */
  var attribPushed = false, attribApresAjout = false;
  function pushAttribToCart(force) {
    if (attribPushed && !force) return;
    attribPushed = true;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {
          gclid: attrib.gclid || '', epik: attrib.epik || '',
          utm_source: attrib.utm_source || '', utm_campaign: attrib.utm_campaign || '',
          cro_visitor: visitorId, cro_session: sessionId,
          // Version du test en cours seulement : une version gardée d'un test arrêté ne part plus dans les commandes.
          cro_ab: CORE.ab ? CORE.ab.t + '|' + CORE.ab.v : '',
          cro_ab_page: CORE.abp ? CORE.abp.t + '|' + CORE.abp.v : (ls('cro_abp') || ''),
          // Programme de tests (11/10/2026) : « id|V » de chaque test en cours, séparés par des virgules.
          cro_tests: CORE.tests ? Object.keys(CORE.tests).map(function (z) { return CORE.tests[z].t + '|' + CORE.tests[z].v; }).join(',') : '',
        } }),
      }).catch(function () {});
    } catch (e) {}
  }

  /* ── vue de page ── */
  track('page_view', { meta: metaP({ tjs: Math.round(now()), vw: window.innerWidth, vh: window.innerHeight }) });
  if (CFG.productId) track('product_view', { value: CFG.productPrice, currency: DEVISE });
  flush(false);

  /* ── clics ── */
  var CART_FORM = 'form[action*="/cart/add"]';
  var lastAtc = 0, lastCheckout = 0;
  function checkout(el, express) {
    // Le clic sur « Commander » soumet aussi le formulaire du panier : une seule mesure par seconde.
    if (Date.now() - lastCheckout < 1000) return;
    lastCheckout = Date.now();
    // Origine du passage au paiement : tiroir (panier latéral), page panier ou autre (bouton express…).
    var o = el && el.closest ? (el.closest('[data-cro-panier-lateral]') ? 'tiroir' : /\/cart\b/.test(location.pathname) ? 'page_panier' : 'page') : null;
    track('checkout_start', o ? { label: o, meta: metaP(express ? { t: sec(), x: 1 } : { t: sec() }) } : undefined); pushAttribToCart(); flush(false);
  }
  function submits(el) {
    var t = (el.getAttribute('type') || '').toLowerCase();
    return el.tagName === 'INPUT' ? t === 'submit' : (t === '' || t === 'submit');
  }
  function cartFormOf(el) {
    if (!el) return null;
    var inside = el.closest(CART_FORM);
    if (inside) return inside;
    var btn = el.closest('[form]');
    if (btn) {
      var f = document.getElementById(btn.getAttribute('form'));
      if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) return f;
    }
    return null;
  }
  function currentVariant(form) {
    var f = form || document.querySelector(CART_FORM);
    if (!f) return null;
    var i = f.querySelector('[name="id"]:checked') || f.querySelector('[name="id"]');
    return i ? i.value : null;
  }

  /** Nom stable d'une section Shopify : « shopify-section-template--123__faq » → « faq ». */
  function nomSection(el) {
    var b = el && el.closest ? el.closest('[data-cro-bloc]') : null;
    if (b) return String(b.getAttribute('data-cro-bloc')).slice(0, 40);
    var s = el && el.closest ? el.closest('[id^="shopify-section-"]') : null;
    if (!s) return null;
    var m = /__([a-z][a-z0-9_]*?)(?:_[0-9a-zA-Z]{6,})?$/.exec(s.id);
    return m ? m[1] : s.id.replace(/^shopify-section-/, '').slice(0, 24);
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    // 1. Déclaré par le thème. On continue ensuite : un bouton marqué peut aussi soumettre.
    var d = t.closest('[data-cro]');
    if (d) {
      var v = parseFloat(d.getAttribute('data-cro-value'));
      track(d.getAttribute('data-cro'), {
        label: d.getAttribute('data-cro-label') || txt(d, 80),
        value: isNaN(v) ? null : v,
        meta: metaP({ t: sec(), bloc: nomSection(d) }),
      });
    }

    // 2. Ajout au panier — le clic ; l'ajout réussi est lu sur le réseau plus bas.
    var btn = t.closest('button, input[type="submit"]');
    if (btn && submits(btn) && cartFormOf(btn)) {
      lastAtc = Date.now();
      track('add_to_cart_click', { variant_id: currentVariant(cartFormOf(btn)), label: txt(btn, 60),
        meta: metaP({ t: sec(), bloc: nomSection(btn) }) });
      pushAttribToCart();
      return;
    }

    // 3. Accordéons natifs : au moment du clic, <details> n'a pas encore basculé.
    var sum = t.closest('summary');
    if (sum) {
      var det = sum.parentElement;
      if (det && det.tagName === 'DETAILS' && !det.open) {
        var bloc = nomSection(sum);
        track(/faq/.test(bloc || '') ? 'faq_open' : 'section_open',
          { label: txt(sum, 200), meta: metaP({ t: sec(), bloc: bloc }) });
      }
      return;
    }

    if (d) return;
    if (t.closest('a[href$="/cart"], a[href*="/cart?"], a[href="/cart"], [data-cro-panier]')) { panierOuvert('lien'); return; }
    if (t.closest('[name="checkout"], a[href*="/checkout"]')) { checkout(t); return; }
    // Paiement express : les boutons sont dans le shadow DOM de Shopify, le clic arrive sur l'élément hôte.
    if (t.closest('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .rs-express')) { checkout(t, true); return; }
  }, true);

  // Formulaire soumis sans clic (touche Entrée, requestSubmit d'une barre fixe…).
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.matches && f.matches(CART_FORM) && Date.now() - lastAtc > 1000) {
      lastAtc = Date.now();
      track('add_to_cart_click', { variant_id: currentVariant(f), label: 'submit', meta: metaP({ t: sec() }) });
      pushAttribToCart();
    }
    if (f && f.matches && f.matches('form[action*="/cart"]') && f.querySelector('[name="checkout"]') && ev.submitter &&
        ev.submitter.getAttribute('name') === 'checkout') {
      checkout(ev.submitter);
    }
  }, true);

  /* ── ajout au panier confirmé : la réponse de Shopify fait foi ── */
  function trackAdded(payload) {
    var items = payload && payload.items ? payload.items : [payload];
    var vu = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !it.product_id) continue;
      vu = true;
      track('add_to_cart', {
        product_id: String(it.product_id),
        variant_id: it.variant_id ? String(it.variant_id) : null,
        label: it.product_title || it.title || null,
        value: typeof it.final_line_price === 'number' ? it.final_line_price / 100 :
               typeof it.price === 'number' ? it.price / 100 * (it.quantity || 1) : null,
        currency: DEVISE,
        meta: metaP({ qte: it.quantity || 1, variante: it.variant_title || null, t: sec() }),
      });
    }
    if (!vu) track('add_to_cart', { variant_id: currentVariant() });
    // Envoyés au clic, les attributs peuvent précéder la création du panier et se perdre : renvoyés
    // une fois après le premier ajout confirmé (identifiant visiteur et version A/B jusqu'à la commande).
    if (!attribApresAjout) { attribApresAjout = true; pushAttribToCart(true); }
    flush(false);
  }
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (String(url).indexOf('/cart/add') !== -1) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          r.clone().json().then(trackAdded).catch(function () { track('add_to_cart', { variant_id: currentVariant() }); });
        }).catch(function () {});
      }
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (String(url).indexOf('/cart/add') !== -1) {
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        try { trackAdded(JSON.parse(this.responseText)); }
        catch (e) { track('add_to_cart', { variant_id: currentVariant() }); }
      });
    }
    return _open.apply(this, arguments);
  };

  /* ── profondeur de défilement ── */
  var marks = [25, 50, 75, 100], hit = {};
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return;
    var p = ((window.scrollY || window.pageYOffset) / h) * 100;
    for (var i = 0; i < marks.length; i++) {
      if (p >= marks[i] && !hit[marks[i]]) { hit[marks[i]] = 1; track('scroll_depth', { value: marks[i] }); }
    }
  }
  var scrollTimer;
  window.addEventListener('scroll', function () {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function () { scrollTimer = null; onScroll(); }, 300);
  }, { passive: true });

  /* ── blocs réellement vus ──
     Ancré sur le CONTENU (nom de la section), pas sur un pourcentage de hauteur : traverse les
     refontes et permet de comparer deux pages produit bloc par bloc. Vu = la moitié du bloc, ou
     un écran plein pour les blocs plus hauts que la fenêtre, visible une seconde pleine.
     L'entonnoir se lit sur label ; value = rang du bloc ce jour-là ; meta.t = s depuis l'arrivée. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var sections;
    try {
      // Repères posés dans la page (data-cro-bloc, 16/10/2026) : une page faite d'une seule section (advertorial)
      // est découpée en blocs nommés ; sinon les sections Shopify du modèle.
      sections = [].slice.call(document.querySelectorAll('[data-cro-bloc]'));
      if (!sections.length) sections = [].slice.call(document.querySelectorAll('[id^="shopify-section-template--"]'))
        .filter(function (el) { return el.offsetHeight > 120; });
    } catch (e) { return; }
    if (!sections.length) return;
    var vus = {}, attentes = {};
    function surveiller(el, haut) {
      return function (entrees) {
        entrees.forEach(function (e) {
          var cle = el.id || nomSection(el);
          if (vus[cle]) return;
          if (e.isIntersecting) {
            if (attentes[cle]) return;
            attentes[cle] = setTimeout(function () {
              attentes[cle] = null;
              if (vus[cle]) return;
              vus[cle] = 1;
              var m = { t: sec() }; if (haut) m.haut = 1;
              track('bloc_vu', { label: nomSection(el), value: sections.indexOf(el) + 1, meta: metaP(m) });
            }, 1000);
          } else if (attentes[cle]) {
            clearTimeout(attentes[cle]); attentes[cle] = null;
          }
        });
      };
    }
    sections.forEach(function (el) {
      if (el.offsetHeight > window.innerHeight) {
        new IntersectionObserver(surveiller(el, true), { threshold: 0, rootMargin: '-40% 0px -40% 0px' }).observe(el);
      } else {
        new IntersectionObserver(surveiller(el, false), { threshold: [0.5] }).observe(el);
      }
    });
  })();

  /* ── panier latéral : ouverture et fermeture, y compris l'ouverture automatique après un ajout ──
     Sans cela, « panier ouvert » restait à zéro : le thème ouvre le tiroir sans aucun clic. */
  var dernierPanier = 0;
  function panierOuvert(origine) {
    if (Date.now() - dernierPanier < 2000) return; // un clic sur « panier » ouvre aussi le tiroir : une seule mesure
    dernierPanier = Date.now();
    track('cart_open', { label: origine, meta: metaP({ t: sec() }) });
    flush(false);
  }
  // Ouvert = réellement visible (aria-hidden, visibility, opacité) : un tiroir fermé reste souvent dans l'écran,
  // simplement masqué, donc sa position ne dit rien.
  (function () {
    if (!window.MutationObserver) return;
    function estOuvert(el) {
      // aria-hidden bascule dès l'ouverture ; la visibilité calculée, elle, attend la fin de l'animation.
      if (el.hasAttribute('aria-hidden')) return el.getAttribute('aria-hidden') !== 'true';
      var cs = getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.1;
    }
    function brancher() {
      var el = document.querySelector('[data-cro-panier-lateral]');
      if (!el) return;
      var depuis = estOuvert(el) ? Date.now() : 0;
      function verifier() {
        var o = estOuvert(el);
        if (o && !depuis) { depuis = Date.now(); panierOuvert(Date.now() - lastAtc < 5000 ? 'après ajout' : 'tiroir'); }
        else if (!o && depuis) {
          var d = Math.round((Date.now() - depuis) / 100) / 10;
          depuis = 0;
          if (document.visibilityState === 'visible') { track('cart_close', { value: d, meta: metaP({ t: sec() }) }); flush(false); }
        }
      }
      function bientot() { setTimeout(verifier, 50); setTimeout(verifier, 600); }
      new MutationObserver(bientot).observe(el, { attributes: true, attributeFilter: ['aria-hidden', 'class', 'style', 'hidden'] });
      new MutationObserver(bientot).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher); else brancher();
  })();

  /* ── éléments déclarés « à voir » (data-cro-vu) : une fois par page ── */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var envoyes = {};
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        var nom = e.target.getAttribute('data-cro-vu');
        if (envoyes[nom]) return;
        envoyes[nom] = 1;
        obs.unobserve(e.target);
        track(nom, { label: e.target.getAttribute('data-cro-label') || null, meta: metaP({ t: sec() }) });
      });
    }, { threshold: [0.5] });
    function brancher() { [].forEach.call(document.querySelectorAll('[data-cro-vu]'), function (el) { obs.observe(el); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher); else brancher();
  })();

  /* ── clics de rage : 3 clics au même endroit en moins d'une seconde ── */
  var recent = [];
  document.addEventListener('click', function (ev) {
    var n = Date.now();
    recent = recent.filter(function (c) { return n - c.t < 1000; });
    recent.push({ t: n, x: ev.clientX, y: ev.clientY });
    if (recent.length >= 3 && recent.every(function (c) {
      return Math.abs(c.x - recent[0].x) < 40 && Math.abs(c.y - recent[0].y) < 40;
    })) {
      recent = [];
      track('rage_click', { label: cible(ev.target), meta: metaP({ bloc: nomSection(ev.target) }) });
    }
  }, true);

  /* ── premier geste et temps passé ── */
  var arrived = Date.now(), firstClick = null;
  document.addEventListener('click', function (ev) {
    if (firstClick !== null) return;
    firstClick = Date.now() - arrived;
    track('first_click', { value: Math.round(firstClick / 1000), label: cible(ev.target),
      meta: metaP({ t: sec(), bloc: nomSection(ev.target) }) });
  }, true);

  /** Ce qui a été touché : déclaration du thème, sinon balise, classe et texte. */
  function cible(el) {
    if (!el || !el.closest) return null;
    var d = el.closest('[data-cro]');
    if (d) return d.getAttribute('data-cro');
    var x = el.closest('a, button, summary, label, input, select, [role="button"]') || el;
    var c = typeof x.className === 'string' ? x.className.split(' ')[0] : '';
    var s = txt(x, 40);
    return (x.tagName.toLowerCase() + (c ? '.' + c : '') + (s ? ' ' + s : '')).slice(0, 80);
  }

  var defile = false;
  window.addEventListener('scroll', function () {
    if (defile || (window.scrollY || window.pageYOffset) < 60) return;
    defile = true;
    track('first_scroll', { value: sec(), meta: metaP({}) });
  }, { passive: true });

  /* ── vitesse vécue (Safari ne fournit ni LCP ni INP) ── */
  var perf = { cls: 0, inp: 0 }, perfEnvoye = false;
  function observer(type, cb, extra) {
    try {
      var o = { type: type, buffered: true };
      if (extra) for (var k in extra) o[k] = extra[k];
      new PerformanceObserver(function (l) { l.getEntries().forEach(cb); }).observe(o);
    } catch (e) {}
  }
  function decrire(el) {
    if (!el || !el.tagName) return null;
    var s = el.tagName.toLowerCase(), c = typeof el.className === 'string' ? el.className.split(' ')[0] : '';
    if (c) s += '.' + c;
    var src = el.currentSrc || el.src || '';
    if (src) s += ' ' + src.split('/').pop().split('?')[0].slice(0, 28);
    return s.slice(0, 70);
  }
  observer('paint', function (e) { if (e.name === 'first-contentful-paint') perf.fcp = Math.round(e.startTime); });
  observer('largest-contentful-paint', function (e) {
    perf.lcp = Math.round(e.startTime);
    perf.le = decrire(e.element) || (e.url ? 'img ' + e.url.split('/').pop().split('?')[0].slice(0, 40) : null);
  });
  observer('layout-shift', function (e) { if (!e.hadRecentInput) perf.cls += e.value; });
  observer('event', function (e) { if (e.interactionId && e.duration > perf.inp) perf.inp = Math.round(e.duration); },
    { durationThreshold: 40 });
  function envoyerPerf() {
    if (perfEnvoye) return;
    perfEnvoye = true;
    var m = { fcp: perf.fcp || null, lcp: perf.lcp || null, le: perf.le || null,
      cls: Math.round(perf.cls * 1000) / 1000, inp: perf.inp || null };
    try {
      var n = performance.getEntriesByType('navigation')[0];
      if (n) {
        m.ttfb = Math.round(n.responseStart);
        m.dcl = Math.round(n.domContentLoadedEventEnd) || null;
        m.load = Math.round(n.loadEventEnd) || null;
        m.ko = Math.round((n.transferSize || 0) / 1024) || null;
      }
    } catch (e) {}
    track('perf', { value: m.lcp, meta: metaP(m) });
  }

  /* ── onglet restauré depuis le cache (Safari iOS) : le script ne se relance pas ── */
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    var inactif = Date.now() - (+(st('cro_seen') || 0));
    if (inactif > SESSION_MAX_IDLE) {
      sessionId = st('cro_sid', uid()) || uid();
      clarityTagge = false;
      attribPushed = false;
    }
    arrived = Date.now(); base = now(); hit = {};
    track('page_view', { label: 'retour (onglet restauré)', value: Math.round(inactif / 1000) });
    if (CFG.productId) track('product_view', { value: CFG.productPrice, currency: DEVISE });
    flush(false);
  });

  function leave() {
    envoyerPerf();
    track('page_leave', { value: Math.round((Date.now() - arrived) / 1000) });
    flush(true);
  }
  window.addEventListener('pagehide', leave);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { envoyerPerf(); flush(true); }
  });
})();
